(() => {
  if (customElements.get('reviews-carousel')) {
    return;
  }

  class ReviewsCarousel extends customElements.get(
    'slider-component'
  ) {
    constructor() {
      super();
      this.options = {
        ...this.options,
        ...{
          spaceBetween: 22,
          slidesPerView: 1,
          loop: true
        },
        breakpoints: {
          1200: {
            slidesPerView: 2
          }
        }
      };
    }
  }

  customElements.define('reviews-carousel', ReviewsCarousel);
})();
